import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { employeeActivityReportRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const employeeActivityReportRouteMetadata: IRouteMetadataObj<
  typeof employeeActivityReportRoutesObj
> = {
  list: {
    title: "reportManagement.index.title",
    description: "empty",
    lazy: () =>
      import("@pages/reportManagement/employeeActivityReport/table/page"),
    mode: "index",
    type: "main",
    icon: "FileChartLine",
    breadcrumbs: [],
    permission,
  },
};

export const employeeActivityReportRoutes = createRoute<
  typeof employeeActivityReportRoutesObj
>(employeeActivityReportRoutesObj, employeeActivityReportRouteMetadata);
